import { render, staticRenderFns } from "./EnglishResumeEdit.vue?vue&type=template&id=22a63247&scoped=true"
import script from "./EnglishResumeEdit.vue?vue&type=script&lang=js"
export * from "./EnglishResumeEdit.vue?vue&type=script&lang=js"
import style0 from "./EnglishResumeEdit.vue?vue&type=style&index=0&id=22a63247&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a63247",
  null
  
)

export default component.exports